<template>
  <div id="previewPage" :style="previewPageStyle">
    <div id="previewContainer">
      <div id="titleContainer" @touchstart="ontouchstart($event)" @touchmove="ontouchmove($event)">
        <div id="previewIssueTitle">第一期 · 后直播时代</div>
        <div id="close_bt" @click="openclose()"><img src="../assets/preview_close_bt.png"/></div>
      </div>
      <div id="ClassLabelArea">
        <div id="LabelContainer">
          <div class="LabelTextContainer LabelTextContainerLeft">
            <div class="ClassLabel" :class="{selectLabel:select==2}" @click="select=2">推荐</div>
<!--            <div class="ClassLabel" :class="{selectLabel:select==2}" @click="select=2">后直播时代</div>-->
          </div>
          <div class="LabelTextContainer LabelTextContainerRight">
            <div class="ClassLabel" :class="{selectLabel:select==3}" @click="select=3">人物说</div>
          </div>
        </div>
      </div>
      <div id="ListContainer" :style="ListContainerStyle">
        <component style="background: #f1f1f1" :is="'class'+select"></component>
      </div>
    </div>
  </div>
</template>

<script>
import class2 from "./previewClass2";
import class3 from "./previewClass3";
import pageStackStore from "../store/pageStackStore";
import store from "../store/";

export default {
  name: "preview",
  data:function (){
    return {
      select:2,
      touch:{x:0,y:0}
    }
  },
  components:{
    class2,
    class3
  },
  methods:{
    openclose(){
      pageStackStore.commit("OpenClose")
    },
    ontouchstart(e){
      this.touch.y=e.changedTouches[0].clientY
    },
    ontouchmove(e){
      if((e.changedTouches[0].clientY-this.touch.y)*this.p>100){
        if(pageStackStore.state.preveiwOpen) {
          pageStackStore.commit("OpenClose")
        }
      }
    }
  },
  computed:{
    previewPageStyle(){
      return {
        height:(store.state.WindowSize.WindowHeightRem-0.9)+'rem'
      }
    },
    ListContainerStyle(){
      return {
        height:(store.state.WindowSize.WindowHeightRem-0.9-1.31-1.11)+'rem'
      }
    },
  }
}
</script>
<style lang="less" scoped>
@fullWidth:11.25rem;
.fullWidhth{
  width: @fullWidth;
}

#previewPage{
  //.fullWidhth();
  width: 100%;

  position: absolute;
  transition-duration: 0.5s;
  top:.9rem;

  #previewContainer{
    //.fullWidhth();
    width: 100%;

    height:100%;
    border-radius:.5rem .5rem 0rem 0rem;
    background: #ffffff;

    #titleContainer{
      .fullWidhth();

      #previewIssueTitle{
        width: 9.45rem;
        margin-left: .9rem;

        height: 1.31rem;
        line-height:1.31rem;
        font-size:.55rem;
        text-align: center;
        color: grey;
      }
      #close_bt{
        width: .33rem;
        margin-top: .51rem;

        img{
          width: 100%;
        }
      }
    }

    #ClassLabelArea{
      .fullWidhth();

      height:1.11rem;
      background: #1a8bff;

      #LabelContainer{
        width: 9.45rem;
        margin-left: .9rem;
        height:1.11rem;
      }
      .LabelTextContainer {
        width: 50%;
        margin-top: .17rem;
        height: .77rem;
        display: flex;
        justify-content: center;

        .ClassLabel {
          font-size: .42rem;
          margin-top: .1rem;
          color: #ffffff;
          padding-bottom: .4rem;
          padding-left: .1rem;
          padding-right: .1rem;
        }
        .selectLabel{
          border-bottom:.07rem solid #ffffff;
        }
      }

      .LabelTextContainerLeft{
        border-right: .01rem solid #ffffff;
      }
      .LabelTextContainerRight{
        border-left: .01rem solid #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preview.vue